import { Component, Inject, OnInit, Optional } from "@angular/core";
import { ModalRef, MODAL_DATA_VAR } from "mis-design-system/mis-modal";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BookingDataService } from "../../../services/booking-data.service";

@Component({
  selector: "mis-employee-web-exp-recurrence-booking-success",
  templateUrl: "./recurrence-booking-success.component.html",
  styleUrls: ["./recurrence-booking-success.component.scss"]
})
export class RecurrenceBookingSuccessComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  bookings: NsEmpWebExpData.IBookingRequestObject;
  failedBookings: NsEmpWebExpData.IFailedBookingResponse[];
  totalBookings: number = 0;
  successBookings: NsEmpWebExpData.ISuccessBookingResponse[];

  constructor(
    public bookingSvc: BookingDataService,
    private modalRef: ModalRef,
    @Optional() private modalref: ModalRef,
    @Inject(MODAL_DATA_VAR) bookings
  ) {
    this.bookings = bookings;
  }

  ngOnInit(): void {
    const recurrenceBookingData = this.bookingSvc?.createRecurrenceResp;
    this.failedBookings = recurrenceBookingData?.failedBookings;
    this.totalBookings = recurrenceBookingData?.totalBookings;
    this.successBookings = recurrenceBookingData?.successBookings;
  }
  close(): void {
    this.modalRef.close();
  }
}
